import { createSlice } from '@reduxjs/toolkit';

// default fields array
const defaultFields = [
  {
    id: 0,
    name: 'heading',
    field_type: 'heading',
    col_width: 12,
    title: 'Heading',
    label: 'Heading',
    placeholder: 'Single line or multiline text area',
    status: true,
    draggable: true,
    index: 0,
  },
  {
    id: 1,
    name: 'sub-heading',
    field_type: 'sub-heading',
    col_width: 12,
    title: 'Sub Heading',
    label: 'Sub Heading',
    placeholder: 'Single line or multiline text area',
    status: true,
    draggable: true,
    index: 1,
  },
  {
    help_text: 'Profile Image will appear in a webpage when the program is published for self enrollment.',
    value: null,
    isDraggable: false,
    isMandatory: false,
    col_width: 12,
    label: 'Profile Image',
    field_type: 'profile_pic',
    placeholder: 'Upload image',
    index: 2,
    name: 'profile_pic',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 12,
    label: 'First Name',
    field_type: 'text',
    placeholder: 'First Name',
    name: 'first_name',
    index: 3,
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: false,
    col_width: 6,
    label: 'Middle Name',
    field_type: 'text',
    placeholder: 'Middle Name',
    index: 4,
    name: 'middle_name',
  },

  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 6,
    label: 'Last Name',
    field_type: 'text',
    placeholder: 'Last Name',
    index: 5,
    name: 'last_name',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 6,
    label: 'Email',
    field_type: 'email',
    placeholder: 'Email',
    index: 6,
    name: 'email',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 6,
    label: 'Confirm Email',
    field_type: 'email',
    placeholder: 'Confirm Email',
    index: 7,
    name: 'confirm_email',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 6,
    label: 'Date Of Birth',
    field_type: 'date',
    placeholder: 'Date Of Birth',
    index: 8,
    name: 'date',
  },
  {
    help_text: null,
    value: null,
    options: ['Male', 'Female', 'Others'],
    isDraggable: false,
    isMandatory: true,
    col_width: 6,
    label: 'Gender',
    field_type: 'dropDown',
    placeholder: 'Gender',
    index: 9,
    name: 'gender',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 4,
    label: 'Country',
    field_type: 'country',
    placeholder: 'Country',
    index: 10,
    name: 'country',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 4,
    label: 'County',
    field_type: 'county',
    placeholder: 'county',
    index: 11,
    name: 'county',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 4,
    label: 'City',
    field_type: 'text',
    placeholder: 'City',
    index: 12,
    name: 'city',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: true,
    col_width: 8,
    label: 'House Number and Street',
    field_type: 'text',
    placeholder: 'House Number and Street',
    index: 13,
    name: 'text',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: false,
    col_width: 4,
    label: 'Post Code',
    field_type: 'text',
    placeholder: 'Post Code',
    index: 14,
    name: 'eir_code',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: false,
    col_width: 4,
    label: 'Country Code',
    field_type: 'phoneCode',
    placeholder: 'Country Code',
    index: 15,
    name: 'country_code',
  },
  {
    help_text: null,
    value: null,
    isDraggable: false,
    isMandatory: false,
    col_width: 8,
    label: 'Phone Number',
    field_type: 'number',
    placeholder: 'Phone Number',
    index: 16,
    name: 'phone',
  },
];

const fields = [
  {
    id: 1,
    name: 'heading',
    field_type: 'heading',
    col_width: 12,
    title: 'Heading',
    label: 'Heading',
    placeholder: 'Single line or multiline text area',
    status: true,
    draggable: true,
    index: null,
  },
  {
    id: 2,
    name: 'sub-heading',
    field_type: 'sub-heading',
    col_width: 12,
    title: 'Sub Heading',
    label: 'Sub Heading',
    placeholder: 'Single line or multiline text area',
    status: true,
    draggable: true,
    index: null,
  },
  {
    id: 3,
    label: 'label',
    help_text: 'this is a help text',
    field_type: 'text',
    col_width: 12,
    title: 'Input Text',
    description: 'Single line text field',
    placeholder: 'placeholder',
    name: 'text',
  },
  {
    id: 4,
    field_type: 'textarea',
    title: 'Textarea Title',
    label: 'Textarea Label',
    col_width: 12,
    value: '',
    description: 'Multiple input text area',
    helperText: 'Helper Text',
    placeholder: 'Enter description here...',
    name: 'text_area',
  },
  // dropdown
  {
    id: 5,
    field_type: 'dropDown',
    title: 'Dropdown Block',
    label: 'Dropdown Block',
    description: 'Single select dropdown',
    // profile_img_url: '',
    // profile_img_helper_text: 'Upload Image file type of jpg/png only . Max size 1024kb',
    // placeholder: 'Enter description here...',
    // profile_description: '',
    name: 'dropDown',
  },
  //   datepicker
  {
    id: 6,
    field_type: 'date',
    title: 'Date Block',
    label: 'Date Block',
    description: 'date picker',
    placeholder: 'Date',
    name: 'date',
  },
];
const initialState = {
  activeEle: '',
  fields,
  mode: 'view',
  elements: [],
  loader: false,
  isDraged: false,
  form: {},
  defaultFields,
  type: '',
};

export const registrationFormBuilderSlice = createSlice({
  name: 'registrationFormBuilder',
  initialState,
  reducers: {
    setActiveRegistrationEle: (state, action) => {
      return { ...state, activeEle: action.payload };
    },
    setIsRegistrationDraged: (state, action) => {
      return { ...state, isDraged: action.payload };
    },
    setRegistrationFields: (state, action) => {
      return { ...state, fields: action.payload };
    },
    setRegistrationElements: (state, action) => {
      return { ...state, elements: action.payload };
    },
    addRegistrationElement: (state, action) => {
      return { ...state, elements: [...state.elements, action.payload] };
    },
    addElements: (state, action) => {
      return { ...state, elements: [...state.elements, ...action.payload] };
    },
    setElements: (state, action) => {
      return { ...state, elements: action.payload };
    },
    setMode: (state, action) => {
      return { ...state, mode: action.payload };
    },
    setForm: (state, action) => {
      return { ...state, form: action.payload };
    },
    updateElement: (state, action) => {
      // console.log(action.payload);
      let elementsClone = [...state.elements];
      let obj = elementsClone.find((item) => item.id === action.payload.id);
      let index = elementsClone.indexOf(obj);
      elementsClone[index] = action.payload;
      // console.log(obj);
      // console.log(index);
      return { ...state, elements: [...elementsClone] };
    },
    deleteElement: (state, action) => {
      return { ...state, elements: state.elements.filter((item) => item.id !== action.payload) };
    },

    setRegistrationLoader: (state, action) => {
      return { ...state, loader: action.payload };
    },

    setType: (state, action) => {
      return { ...state, type: action.payload };
    },
  },
});

export const {
  setActiveRegistrationEle,
  setRegistrationFields,
  setForm,
  setRegistrationElements,
  addRegistrationElement,
  setMode,
  deleteElement,
  addElements,
  setIsRegistrationDraged,
  updateElement,
  setRegistrationLoader,
  setType,
} = registrationFormBuilderSlice.actions;
export default registrationFormBuilderSlice.reducer;
